import { serializable, alias, object, list, primitive } from 'serializr';


export class FilterChapterwise {
    @serializable(alias('institute_id', primitive()))
    instituteId?: number;

    @serializable(alias('branch_id', primitive()))
    branchId?: number;

    @serializable(alias('board_id', primitive()))
    boardId?: number;

    @serializable(alias('section_id', primitive()))
    sectionId?: number;

    @serializable(alias('section_subject_id', primitive()))
    sectionSubjectId?: number;

    @serializable(alias('branch_class_room_id', primitive()))
    branchClassRoomId?: number;

    @serializable(alias('chapter_id', primitive()))
    chapterId?: string;

    @serializable(alias('type', primitive()))
    type?: string;
}

export class ContentModel {
    @serializable(alias("name", primitive()))
    name?: string;
    @serializable(alias("status", primitive()))
    status?: string;
    @serializable(alias("points", primitive()))
    points?: string;
    @serializable(alias("quickquiz", primitive()))
    quickquiz?: string;
    @serializable(alias("quickquizpoint", primitive()))
    quickquizpoint?: string;
}



export class ChapterwiseSummaryModel {
    @serializable(alias("id", primitive()))
    id?: number;
    @serializable(alias("name", primitive()))
    name?: string;
    @serializable(alias("grade", primitive()))
    grade?: string;
    @serializable(alias("section", primitive()))
    section?: string;
    @serializable(alias("content_completion", primitive()))
    contentCompletion?: string;
    @serializable(alias("total_quick_quiz_points", primitive()))
    totalQuickQuizPoints?: string;
    @serializable(alias("exercise_attempted", primitive()))
    exerciseAttempted?: string;
    @serializable(alias("total_exercieses_points", primitive()))
    totalExerciesesPoints?: string;
    @serializable(alias("over_all_chapter_points", primitive()))
    overAllChapterPoints?: string;
    @serializable(alias("total_hours_for_chapter", primitive()))
    totalHoursForChapter?: string;
    @serializable(alias("content_completion_points", primitive()))
    contentCompletionPoints?: string;
    @serializable(alias("quick_quiz_attempted", primitive()))
    quickQuizAttempted?: string;    
}
